export const ART_FILTER_FULL = 'ART_FILTER_FULL'
export const ART_FILTER_FAVORITES = 'ART_FILTER_FAVORITES'

export const DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE = 'DESIGN_SIDEPANEL_MODE_PRODUCT_BROWSE'
export const DESIGN_SIDEPANEL_MODE_PRODUCT_DETAILS = 'DESIGN_SIDEPANEL_MODE_PRODUCT_DETAILS'
export const DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE = 'DESIGN_SIDEPANEL_MODE_MYITEMS_BROWSE'
export const DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS = 'DESIGN_SIDEPANEL_MODE_MYITEMS_DETAILS'
export const DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE = 'DESIGN_SIDEPANEL_MODE_FAVORITES_BROWSE'
export const DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS = 'DESIGN_SIDEPANEL_MODE_FAVORITES_DETAILS'
export const DESIGN_SIDEPANEL_MODE_SWAP_BROWSE = 'DESIGN_SIDEPANEL_MODE_SWAP_BROWSE'
export const DESIGN_SIDEPANEL_MODE_SWAP_DETAILS = 'DESIGN_SIDEPANEL_MODE_SWAP_DETAILS'
export const DESIGN_SIDEPANEL_MODE_OPTIONS = 'DESIGN_SIDEPANEL_MODE_OPTIONS'
export const DESIGN_SIDEPANEL_MODE_DEBUG = 'DESIGN_SIDEPANEL_MODE_DEBUG'
export const DESIGN_SIDEPANEL_MODE_RATE = 'DESIGN_SIDEPANEL_MODE_RATE'

export const MY_ITEMS_BROWSE_NUM_COLUMNS = 1
export const FURNITURE_BROWSE_NUM_COLUMNS = 3
export const FURNITURE_SWAP_NUM_COLUMNS = 3

// constants used in react-screen-orientation library, do not change
export const ORIENTATION_LANDSCAPE = 'landscape'
export const ORIENTATION_PORTRAIT = 'portrait'
